// extracted by mini-css-extract-plugin
module.exports = {"sheduleInterviewDetailsRow":"review_sheduleInterviewDetailsRow__1qOwF","rowSubTitle":"review_rowSubTitle__1_l-G","rowValues":"review_rowValues__1P5wU"};